import moment from 'moment';
import store from '../../component/app/store';
import { REDUCER_NAME as COMMON_REDUCER } from '../app/commonReducer';
import { listLanguage } from '../../configs/LanguageConfig';

export const alertDefinitionByCode = {
  RevenueBreakoutQuarterly: {
    AlertId: '1',
    AlertCode: 'RevenueBreakoutQuarterly',
    SubscribeCode: 'RevenueBreakoutQuarterly',
    AlertName: 'Bứt phá doanh thu (quý)',
    En_AlertName: 'Break-out Revenue (Quarterly)',
    AlertType: 'Fundamental',
    AlertGroup: 'Notification.Fundamental',
    Status: '1',
    Vi_NotificationTemplate: 'Có doanh thu tăng {0}%  trong Quý {2} - {1}',
    En_NotificationTemplate:
      'Has increased revenue by {0} in Quarter {2} - {1}',
    SortOrder: '1',
  },
  ProfitBreakoutQuarterly: {
    AlertId: '2',
    AlertCode: 'ProfitBreakoutQuarterly',
    SubscribeCode: 'ProfitBreakoutQuarterly',
    AlertName: 'Bứt phá lợi nhuận (quý)',
    En_AlertName: 'Break-out Profit (Quarterly)',
    AlertType: 'Fundamental',
    AlertGroup: 'Notification.Fundamental',
    Status: '1',
    Vi_NotificationTemplate: 'Có lợi nhuận tăng {0}%  trong Quý {2} - {1}',
    En_NotificationTemplate:
      'Has increased profit by {0}% in Quarter {2} - {1}',
    SortOrder: '2',
  },
  RevenueBreakoutYear: {
    AlertId: '3',
    AlertCode: 'RevenueBreakoutYear',
    SubscribeCode: 'RevenueBreakoutYear',
    AlertName: 'Bứt phá doanh thu (năm)',
    En_AlertName: 'Break-out Revenue (Year)',
    AlertType: 'Fundamental',
    AlertGroup: 'Notification.Fundamental',
    Status: '1',
    Vi_NotificationTemplate: 'Có doanh thu tăng {0}%  trong Năm {1}',
    En_NotificationTemplate: 'Has increased revenue by {0}% in Year {1}',
    SortOrder: '3',
  },
  ProfitBreakoutYear: {
    AlertId: '4',
    AlertCode: 'ProfitBreakoutYear',
    SubscribeCode: 'ProfitBreakoutYear',
    AlertName: 'Bứt phá lợi nhuận (năm)',
    En_AlertName: 'Break-out Profit (Year)',
    AlertType: 'Fundamental',
    AlertGroup: 'Notification.Fundamental',
    Status: '1',
    Vi_NotificationTemplate: 'Có Lợi nhuận tăng {0}%  trong Năm {1}',
    En_NotificationTemplate: 'Has increased profit by {0}% in Year {1}',
    SortOrder: '4',
  },
  RevenueFallDownQuarterly: {
    AlertId: '5',
    AlertCode: 'RevenueFallDownQuarterly',
    SubscribeCode: 'RevenueFallDownQuarterly',
    AlertName: 'Sụt giảm doanh thu (quý)',
    En_AlertName: 'Fall Down Revenue (Quarterly)',
    AlertType: 'Fundamental',
    AlertGroup: 'Notification.Fundamental',
    Status: '1',
    Vi_NotificationTemplate: 'Có doanh thu sụt giảm {0}%  trong Quý {2} - {1}',
    En_NotificationTemplate:
      'Has decreased revenue by {0}% in Quarter {2} - {1}',
    SortOrder: '5',
  },
  ProfitFallDownQuarterly: {
    AlertId: '8',
    AlertCode: 'ProfitFallDownQuarterly',
    SubscribeCode: 'ProfitFallDownQuarterly',
    AlertName: 'Sụt giảm lợi nhuận (quý)',
    En_AlertName: 'Fall Down Profit (Quarterly)',
    AlertType: 'Fundamental',
    AlertGroup: 'Notification.Fundamental',
    Status: '1',
    Vi_NotificationTemplate: 'Có lợi nhuận sụt giảm {0}%  trong Quý {2} - {1}',
    En_NotificationTemplate:
      'Has decreased profit by {0}% in Quarter {2} - {1}',
    SortOrder: '6',
  },
  RevenueFallDownYear: {
    AlertId: '9',
    AlertCode: 'RevenueFallDownYear',
    SubscribeCode: 'RevenueFallDownYear',
    AlertName: 'Sụt giảm doanh thu (năm)',
    En_AlertName: 'Fall Down Revenue (Year)',
    AlertType: 'Fundamental',
    AlertGroup: 'Notification.Fundamental',
    Status: '1',
    Vi_NotificationTemplate: 'Có doanh thu sụt giảm {0}%  trong Năm {1}',
    En_NotificationTemplate: 'Has decreased revenue by {0}% in Year {1}',
    SortOrder: '7',
  },
  ProfitFallDownYear: {
    AlertId: '10',
    AlertCode: 'ProfitFallDownYear',
    SubscribeCode: 'ProfitFallDownYear',
    AlertName: 'Sụt giảm lợi nhuận (năm)',
    En_AlertName: 'Fall Down Profit (Year)',
    AlertType: 'Fundamental',
    AlertGroup: 'Notification.Fundamental',
    Status: '1',
    Vi_NotificationTemplate: 'Có lợi nhuận sụt giảm {0}%  trong Năm {1}',
    En_NotificationTemplate: 'Has decreased profit by {0}% in Year {1}',
    SortOrder: '8',
  },
  WatchoutQuarter: {
    AlertId: '12',
    AlertCode: 'WatchoutQuarter',
    SubscribeCode: 'WatchoutQuarter',
    AlertName:
      'Doanh nghiệp có tình hình tài chính cần chú ý (Đánh giá theo năm)',
    En_AlertName: 'Watch-out Quarter',
    AlertType: 'Fundamental',
    AlertGroup: 'Notification.Fundamental',
    Status: '1',
    Vi_NotificationTemplate:
      'Chỉ tiêu {0} bị đánh giá Nguy hiểm trong kỳ đánh giá Quý {1}-{2}',
    En_NotificationTemplate:
      'Indicator {0} is rated Watch-Out in Quarter {1}-{2} of the Review Period',
    SortOrder: '9',
  },
  UpgradeScoringIndustryTop1: {
    AlertId: '13',
    AlertCode: 'UpgradeScoringIndustryTop1',
    SubscribeCode: 'UpgradeScoringIndustry',
    AlertName: 'Cập nhật xếp hạng (theo ngành)',
    En_AlertName: 'Upgrade ranking (Industry)',
    AlertType: 'Fundamental',
    AlertGroup: 'Notification.Fundamental',
    Status: '1',
    Vi_NotificationTemplate: 'Đứng đầu ngành {0} trong kỳ Review Quý {1}-{2}',
    En_NotificationTemplate:
      'Ranks 1st in {0} industry in the Quarterly Review {1}-{2}',
    SortOrder: '10',
  },
  UpgradeScoringIndustryTop3: {
    AlertId: '14',
    AlertCode: 'UpgradeScoringIndustryTop3',
    SubscribeCode: 'UpgradeScoringIndustry',
    AlertName: 'Cập nhật xếp hạng (theo ngành)',
    En_AlertName: 'Upgrade ranking (Industry)',
    AlertType: 'Fundamental',
    AlertGroup: 'Notification.Fundamental',
    Status: '1',
    Vi_NotificationTemplate:
      'Lọt vào top 3 của ngành {0} trong kỳ Review Quý {1}-{2}',
    En_NotificationTemplate:
      'Enteres the top 3 of the {0} industry in the Quarterly Review {1}-{2}',
    SortOrder: '11',
  },
  UpgradeScoringIndustryOutTop: {
    AlertId: '15',
    AlertCode: 'UpgradeScoringIndustryOutTop',
    SubscribeCode: 'UpgradeScoringIndustry',
    AlertName: 'Cập nhật xếp hạng (theo ngành)',
    En_AlertName: 'Upgrade ranking (Industry)',
    AlertType: 'Fundamental',
    AlertGroup: 'Notification.Fundamental',
    Status: '1',
    Vi_NotificationTemplate:
      'Bị ra khỏi top 3 của ngành {0} trong kỳ Review Quý {1}-{2}',
    En_NotificationTemplate:
      'Is out of the top 3 of the {0} industry in the Quarterly Review {1}-{2}',
    SortOrder: '12',
  },
  UpgradeScoringGroupTop1: {
    AlertId: '16',
    AlertCode: 'UpgradeScoringGroupTop1',
    SubscribeCode: 'UpgradeScoringGroup',
    AlertName: 'Cập nhật xếp hạng (theo nhóm chỉ số)',
    En_AlertName: 'Upgrade ranking (Group)',
    AlertType: 'Fundamental',
    AlertGroup: 'Notification.Fundamental',
    Status: '1',
    Vi_NotificationTemplate: 'Đứng đầu nhóm {0} trong kỳ Review Quý {1}-{2}',
    En_NotificationTemplate:
      'Ranks 1st in {0} group in the Quarterly Review {1}-{2}',
    SortOrder: '13',
  },
  UpgradeScoringGroupTop10: {
    AlertId: '18',
    AlertCode: 'UpgradeScoringGroupTop10',
    SubscribeCode: 'UpgradeScoringGroup',
    AlertName: 'Cập nhật xếp hạng (theo nhóm chỉ số)',
    En_AlertName: 'Upgrade ranking (Group)',
    AlertType: 'Fundamental',
    AlertGroup: 'Notification.Fundamental',
    Status: '1',
    Vi_NotificationTemplate:
      'Lọt vào top 10 của nhóm {0} trong kỳ Review Quý {1}-{2}',
    En_NotificationTemplate:
      'Enteres the top 10 of the {0} group in the Quarterly Review {1}-{2}',
    SortOrder: '14',
  },
  UpgradeScoringGroupOutTop: {
    AlertId: '19',
    AlertCode: 'UpgradeScoringGroupOutTop',
    SubscribeCode: 'UpgradeScoringGroup',
    AlertName: 'Cập nhật xếp hạng (theo nhóm chỉ số)',
    En_AlertName: 'Upgrade ranking (Group)',
    AlertType: 'Fundamental',
    AlertGroup: 'Notification.Fundamental',
    Status: '1',
    Vi_NotificationTemplate:
      'Bị ra khỏi top 10 của nhóm {0} trong kỳ Review Quý {1}-{2}',
    En_NotificationTemplate:
      'Is out of the top 10 of the {0} group in the Quarterly Review {1}-{2}',
    SortOrder: '15',
  },
  CEAbnormality: {
    AlertId: '21',
    AlertCode: 'CEAbnormality',
    SubscribeCode: 'CEFLAbnormality',
    AlertName: 'Mua trần/bán sàn đột biến',
    En_AlertName: 'CE/FL Abnormality',
    AlertType: 'Technical',
    AlertGroup: 'Notification.TASignals',
    Status: '1',
    Vi_NotificationTemplate:
      'Dư mua trần đột biến với khối lượng dư mua trần cao hơn 2 lần thanh khoản trung bình 10 phiên',
    En_NotificationTemplate:
      'Excessive purchase of sudden ceiling with ceiling overbought volume 2 times higher than average 10-session liquidity',
    SortOrder: '17',
  },
  FLAbnormality: {
    AlertId: '22',
    AlertCode: 'FLAbnormality',
    SubscribeCode: 'CEFLAbnormality',
    AlertName: 'Mua trần/bán sàn đột biến',
    En_AlertName: 'CE/FL Abnormality',
    AlertType: 'Technical',
    AlertGroup: 'Notification.TASignals',
    Status: '1',
    Vi_NotificationTemplate:
      'Dư bán sàn đột biến với khối lượng dư bán sàn cao hơn 2 lần thanh khoản trung bình 10 phiên',
    En_NotificationTemplate:
      'Excessive selling on the floor with a surplus of selling volume 2 times higher than the average liquidity of 10 sessions',
    SortOrder: '18',
  },
  CancelledBuy: {
    AlertId: '23',
    AlertCode: 'CancelledBuy',
    SubscribeCode: 'Cancelled',
    AlertName: 'Hủy lệnh',
    En_AlertName: 'Cancelled',
    AlertType: 'Technical',
    AlertGroup: 'Notification.TASignals',
    Status: '1',
    Vi_NotificationTemplate:
      'Cổ phiếu có khối lượng lệnh hủy mua trên 30% thanh khoản trung bình 10 phiên',
    En_NotificationTemplate:
      'Stock with a volume of purchase canceling orders above 30% of average liquidity of 10 sessions',
    SortOrder: '19',
  },
  CancelledSell: {
    AlertId: '24',
    AlertCode: 'CancelledSell',
    SubscribeCode: 'Cancelled',
    AlertName: 'Hủy lệnh',
    En_AlertName: 'Cancelled',
    AlertType: 'Technical',
    AlertGroup: 'Notification.TASignals',
    Status: '1',
    Vi_NotificationTemplate:
      'Cổ phiếu có khối lượng lệnh hủy bán trên 30% thanh khoản trung bình 10 phiên',
    En_NotificationTemplate:
      'Stocks with a volume of selling canceling orders above 30% of average 10-session liquidity',
    SortOrder: '20',
  },
  PressingOverlap: {
    AlertId: '25',
    AlertCode: 'PressingOverlap',
    SubscribeCode: 'Pressing',
    AlertName: 'Đè giá/đẩy giá',
    En_AlertName: 'Pressing',
    AlertType: 'Technical',
    AlertGroup: 'Notification.TASignals',
    Status: '1',
    Vi_NotificationTemplate:
      'Cổ phiếu có dấu hiệu đè giá với khối lượng đặt bán tại 1 bước giá lớn',
    En_NotificationTemplate:
      'Stock shows signs of price overlap with volume set for sale at a large price step',
    SortOrder: '21',
  },
  PressingPushing: {
    AlertId: '26',
    AlertCode: 'PressingPushing',
    SubscribeCode: 'Pressing',
    AlertName: 'Đè giá/đẩy giá',
    En_AlertName: 'Pressing',
    AlertType: 'Technical',
    AlertGroup: 'Notification.TASignals',
    Status: '1',
    Vi_NotificationTemplate:
      'Cổ phiếu có dấu hiệu đẩy giá với khối lượng đặt mua tại 1 bước giá lớn',
    En_NotificationTemplate:
      'Stock shows signs of pushing prices with volume ordered at a large price step',
    SortOrder: '22',
  },
  AgressiveBuy: {
    AlertId: '27',
    AlertCode: 'AgressiveBuy',
    SubscribeCode: 'Agressive',
    AlertName: 'Mua/bán chủ động',
    En_AlertName: 'Agressive',
    AlertType: 'Technical',
    AlertGroup: 'Notification.TASignals',
    Status: '1',
    Vi_NotificationTemplate:
      'Cổ phiếu có dấu hiệu mua chủ động với khối lượng mua lên lớn',
    En_NotificationTemplate:
      'Stock shows signs of active buying with large buying volume',
    SortOrder: '23',
  },
  AgressiveSell: {
    AlertId: '28',
    AlertCode: 'AgressiveSell',
    SubscribeCode: 'Agressive',
    AlertName: 'Mua/bán chủ động',
    En_AlertName: 'Agressive',
    AlertType: 'Technical',
    AlertGroup: 'Notification.TASignals',
    Status: '1',
    Vi_NotificationTemplate:
      'Cổ phiếu có dấu hiệu bán chủ động với khối lượng bán xuống lớn',
    En_NotificationTemplate:
      'Stock shows signs of active selling with large selling volume',
    SortOrder: '24',
  },
  Closing: {
    AlertId: '29',
    AlertCode: 'Closing',
    SubscribeCode: 'Closing',
    AlertName: 'Giao dịch đột biến cuối phiên',
    En_AlertName: 'Closing',
    AlertType: 'Technical',
    AlertGroup: 'Notification.TASignals',
    Status: '1',
    Vi_NotificationTemplate:
      'Đang giao dịch với thanh khoản tăng mạnh vào cuối phiên',
    En_NotificationTemplate:
      'Is trading with strong liquidity at the end of the session',
    SortOrder: '25',
  },
  CashDividend: {
    AlertId: '30',
    AlertCode: 'CashDividend',
    SubscribeCode: 'CashDividend',
    AlertName: 'Trả cổ tức tiền mặt',
    En_AlertName: 'Corporate Dividend',
    AlertType: 'Event',
    AlertGroup: 'Notification.Event',
    Status: '1',
    Vi_NotificationTemplate:
      '{0} trả cổ tức bằng tiền năm {1} với tỷ lệ: {2}%, giá trị trên một cổ phiếu: {3}',
    En_NotificationTemplate:
      '{0} pays dividend in {1} with Exercise Rate: {2}%, Value Per share: {3}',
    SortOrder: '26',
  },
  StockDividend: {
    AlertId: '31',
    AlertCode: 'StockDividend',
    SubscribeCode: 'StockDividend',
    AlertName: 'Phát hành cổ phiếu',
    En_AlertName: 'Corporate Share Issuance',
    AlertType: 'Event',
    AlertGroup: 'Notification.Event',
    Status: '1',
    Vi_NotificationTemplate: '{0} {1} với tỷ lệ: {2}%, khối lượng dự kiến: {3}',
    En_NotificationTemplate:
      '{0} {1} with Exercise Ratio: {2}%, plan volume: {3}',
    SortOrder: '27',
  },
  AccumulationBreak: {
    AlertId: '32',
    AlertCode: 'AccumulationBreak',
    SubscribeCode: 'AccumulationBreak',
    AlertName: 'Tích lũy đà tăng',
    En_AlertName: 'Accumulation & Break',
    AlertType: 'Technical',
    AlertGroup: 'Notification.TAStrategy',
    Status: '1',
    Vi_NotificationTemplate:
      'Đang có dấu hiệu bật tăng tốt với thanh khoản lớn từ nền tảng giá tích lũy',
    En_NotificationTemplate:
      'Good signs of rebounding with large liquidity from the cumulative price platform',
    SortOrder: '28',
  },
  BreakoutTop: {
    AlertId: '36',
    AlertCode: 'BreakoutTop',
    SubscribeCode: 'BreakoutTop',
    AlertName: 'Vượt đỉnh',
    En_AlertName: 'Breakout Top',
    AlertType: 'Technical',
    AlertGroup: 'Notification.TAStrategy',
    Status: '1',
    Vi_NotificationTemplate: 'Giá cổ phiếu vượt đỉnh 1 năm với khối lượng lớn',
    En_NotificationTemplate:
      'Stock price surpasses the 1-year peak with high volume',
    SortOrder: '29',
  },
  BreakoutBottom: {
    AlertId: '37',
    AlertCode: 'BreakoutBottom',
    SubscribeCode: 'BreakoutBottom',
    AlertName: 'Phá đáy',
    En_AlertName: 'Breakout Bottom',
    AlertType: 'Technical',
    AlertGroup: 'Notification.TAStrategy',
    Status: '1',
    Vi_NotificationTemplate: 'Giá cổ phiếu thủng đáy 1 năm với khối lượng lớn',
    En_NotificationTemplate:
      'Stock price is  surpassed by the 1-year trough with high volume',
    SortOrder: '30',
  },
  VolumeIncreasePriceIncrease: {
    AlertId: '38',
    AlertCode: 'VolumeIncreasePriceIncrease',
    SubscribeCode: 'VolumeIncreasePriceIncrease',
    AlertName: 'Khối lượng tăng và giá tăng',
    En_AlertName: 'Volume increase & Price increase',
    AlertType: 'Technical',
    AlertGroup: 'Notification.PriceVolume',
    Status: '1',
    Vi_NotificationTemplate: 'Giá tăng và khối lượng tăng liên tục {0} phiên',
    En_NotificationTemplate:
      'Price increases and volume increases continuously {0} session',
    SortOrder: '31',
  },
  VolumeIncreasePriceDecrease: {
    AlertId: '39',
    AlertCode: 'VolumeIncreasePriceDecrease',
    SubscribeCode: 'VolumeIncreasePriceDecrease',
    AlertName: 'Khối lượng tăng và giá giảm',
    En_AlertName: 'Volume increase & Price decrease',
    AlertType: 'Technical',
    AlertGroup: 'Notification.PriceVolume',
    Status: '1',
    Vi_NotificationTemplate: 'Giá giảm và khối lượng tăng liên tục {0} phiên',
    En_NotificationTemplate:
      'Price decreases and volume increases continuously {0} session',
    SortOrder: '32',
  },
  PriceIncrease: {
    AlertId: '40',
    AlertCode: 'PriceIncrease',
    SubscribeCode: 'PriceIncrease',
    AlertName: 'Giá tăng liên tiếp nhiều phiên',
    En_AlertName: 'Price increase in a row',
    AlertType: 'Technical',
    AlertGroup: 'Notification.PriceVolume',
    Status: '1',
    Vi_NotificationTemplate: 'Giá cổ phiếu tăng liên tục {0} phiên',
    En_NotificationTemplate: 'Stock price rises continuously {0} session',
    SortOrder: '33',
  },
  PriceDecrease: {
    AlertId: '41',
    AlertCode: 'PriceDecrease',
    SubscribeCode: 'PriceDecrease',
    AlertName: 'Giá giảm liên tiếp nhiều phiên',
    En_AlertName: 'Price decrease in a row',
    AlertType: 'Technical',
    AlertGroup: 'Notification.PriceVolume',
    Status: '1',
    Vi_NotificationTemplate: 'Giá cổ phiếu giảm liên tục {0} phiên',
    En_NotificationTemplate: 'Stock prices drop continuously {0} session',
    SortOrder: '34',
  },
  VolumeIncrease: {
    AlertId: '42',
    AlertCode: 'VolumeIncrease',
    SubscribeCode: 'VolumeIncrease',
    AlertName: 'Khối lượng tăng liên tiếp nhiều phiên',
    En_AlertName: 'Volume increase in a row',
    AlertType: 'Technical',
    AlertGroup: 'Notification.PriceVolume',
    Status: '1',
    Vi_NotificationTemplate: 'Khối lượng giao dịch tăng liên tục {0} phiên',
    En_NotificationTemplate:
      'Transaction volume increases continuously {0} session',
    SortOrder: '35',
  },
  BreakoutShortermMaCrossup: {
    AlertId: '73',
    AlertCode: 'BreakoutShortermMaCrossup',
    SubscribeCode: 'BreakoutShortermMa',
    AlertName: 'Cắt MA ngắn hạn',
    En_AlertName: 'Breakout Short-term MA',
    AlertType: 'Technical',
    AlertGroup: 'Notification.TAStrategy',
    Status: '1',
    Vi_NotificationTemplate:
      'Giá cổ phiếu vượt đường MA ngắn hạn với khối lượng lớn',
    En_NotificationTemplate:
      'Stock price surpasses short-term MA lines with large volumes',
    SortOrder: '64',
  },
  BreakoutShortermMaCrossdown: {
    AlertId: '74',
    AlertCode: 'BreakoutShortermMaCrossdown',
    SubscribeCode: 'BreakoutShortermMa',
    AlertName: 'Cắt MA ngắn hạn',
    En_AlertName: 'Breakout Short-term MA',
    AlertType: 'Technical',
    AlertGroup: 'Notification.TAStrategy',
    Status: '1',
    Vi_NotificationTemplate:
      'Giá cổ phiếu thủng đường MA ngắn hạn với khối lượng lớn',
    En_NotificationTemplate:
      'Stock price is surpassed by short-term MA lines with large volumes\r',
    SortOrder: '65',
  },
  BreakoutLongtermMaCrossup: {
    AlertId: '75',
    AlertCode: 'BreakoutLongtermMaCrossup',
    SubscribeCode: 'BreakoutLongtermMa',
    AlertName: 'Cắt MA dài hạn',
    En_AlertName: 'Breakout Long-term MA',
    AlertType: 'Technical',
    AlertGroup: 'Notification.TAStrategy',
    Status: '1',
    Vi_NotificationTemplate:
      'Giá cổ phiếu vượt đường MA dài hạn với khối lượng lớn',
    En_NotificationTemplate:
      'Stock price surpasses long-term MA lines with large volumes',
    SortOrder: '66',
  },
  BreakoutLongtermMaCrossdown: {
    AlertId: '76',
    AlertCode: 'BreakoutLongtermMaCrossdown',
    SubscribeCode: 'BreakoutLongtermMa',
    AlertName: 'Cắt MA dài hạn',
    En_AlertName: 'Breakout Long-term MA',
    AlertType: 'Technical',
    AlertGroup: 'Notification.TAStrategy',
    Status: '1',
    Vi_NotificationTemplate:
      'Giá cổ phiếu thủng đường MA dài hạn với khối lượng lớn',
    En_NotificationTemplate:
      'Stock price is surpassed by long-term MA lines in large volumes',
    SortOrder: '67',
  },
  CorporateEarningConsolidatedQ: {
    AlertId: '77',
    AlertCode: 'CorporateEarningConsolidatedQ',
    SubscribeCode: 'CorporateEarning',
    AlertName: 'Kết quả kinh doanh',
    En_AlertName: 'Corporate Earning',
    AlertType: 'Event',
    AlertGroup: 'Notification.Event',
    Status: '1',
    Vi_NotificationTemplate: 'Báo cáo tài chính hợp nhất Q{1}-{0}',
    En_NotificationTemplate: 'Q{1}-{0} consolidated financial statements',
    SortOrder: '128',
  },
  CorporateListing: {
    AlertId: '79',
    AlertCode: 'CorporateListing',
    SubscribeCode: 'CorporateListing',
    AlertName: 'Niêm yết',
    En_AlertName: 'Corporate Listings',
    AlertType: 'Event',
    AlertGroup: 'Notification.Event',
    Status: '1',
    Vi_NotificationTemplate: '{0} Event {1}',
    En_NotificationTemplate: '{0} {1}',
    SortOrder: '129',
  },
  CorporateAgm: {
    AlertId: '80',
    AlertCode: 'CorporateAgm',
    SubscribeCode: 'CorporateAgm',
    AlertName: 'Đại hội cổ đông',
    En_AlertName: 'Corporate Agm',
    AlertType: 'Event',
    AlertGroup: 'Notification.Event',
    Status: '1',
    Vi_NotificationTemplate: '{0} Event {1}',
    En_NotificationTemplate: '{0} {1}',
    SortOrder: '130',
  },
  Economy: {
    AlertId: '81',
    AlertCode: 'Economy',
    SubscribeCode: 'Economy',
    AlertName: 'Sự kiện vĩ mô',
    En_AlertName: 'Economy',
    AlertType: 'Event',
    AlertGroup: 'Notification.Event',
    Status: '1',
    Vi_NotificationTemplate: 'Macro {0} {1}',
    En_NotificationTemplate: 'Macro {0} {1}',
    SortOrder: '131',
  },
  PersonTransactionBuy: {
    AlertId: '82',
    AlertCode: 'PersonTransactionBuy',
    SubscribeCode: 'PersonTransaction',
    AlertName: 'Giao dịch của người nội bộ',
    En_AlertName: 'Person Transaction',
    AlertType: 'Event',
    AlertGroup: 'Notification.Event',
    Status: '1',
    Vi_NotificationTemplate: '{0} mua {1}',
    En_NotificationTemplate: '{0} buys {1}',
    SortOrder: '132',
  },
  CorporateTransactionBuy: {
    AlertId: '83',
    AlertCode: 'CorporateTransactionBuy',
    SubscribeCode: 'CorporateTransaction',
    AlertName: 'Giao dịch của tổ chức',
    En_AlertName: 'Corporate Transaction',
    AlertType: 'Event',
    AlertGroup: 'Notification.Event',
    Status: '1',
    Vi_NotificationTemplate: '{0} mua {1}',
    En_NotificationTemplate: '{0} buys {1}',
    SortOrder: '133',
  },
  Corporate_IPO: {
    AlertId: '84',
    AlertCode: 'Corporate_IPO',
    SubscribeCode: 'Corporate_IPO',
    AlertName: 'Phát hành IPO',
    En_AlertName: 'Corporate IPO',
    AlertType: 'Event',
    AlertGroup: 'Notification.Event',
    Status: '1',
    Vi_NotificationTemplate: '{0} {1} mã {2} thực hiện IPO',
    En_NotificationTemplate: '{0} {1} Ticker {2} IPO',
    SortOrder: '134',
  },
  PersonTransactionSell: {
    AlertId: '86',
    AlertCode: 'PersonTransactionSell',
    SubscribeCode: 'PersonTransaction',
    AlertName: 'Giao dịch của người nội bộ',
    En_AlertName: 'Person Transaction',
    AlertType: 'Event',
    AlertGroup: 'Notification.Event',
    Status: '1',
    Vi_NotificationTemplate: '{0} bán {1}',
    En_NotificationTemplate: '{0} sells {1}',
    SortOrder: '132',
  },
  CorporateTransactionSell: {
    AlertId: '87',
    AlertCode: 'CorporateTransactionSell',
    SubscribeCode: 'CorporateTransaction',
    AlertName: 'Giao dịch của tổ chức',
    En_AlertName: 'Corporate Transaction',
    AlertType: 'Event',
    AlertGroup: 'Notification.Event',
    Status: '1',
    Vi_NotificationTemplate: '{0} bán {1}',
    En_NotificationTemplate: '{0} sells {1}',
    SortOrder: '133',
  },
  BreakoutVolume: {
    AlertId: '88',
    AlertCode: 'BreakoutVolume',
    SubscribeCode: 'BreakoutVolume',
    AlertName: 'Bứt phá khối lượng',
    En_AlertName: 'Breakout volume',
    AlertType: 'Technical',
    AlertGroup: 'Notification.PriceVolume',
    Status: '1',
    Vi_NotificationTemplate: 'Có tín hiệu bứt phá khối lượng và tăng giá',
    En_NotificationTemplate:
      'Has a signal that breakout volume and increasing price',
    SortOrder: '36',
  },
  CorporateEarningConsolidatedY: {
    AlertId: '89',
    AlertCode: 'CorporateEarningConsolidatedY',
    SubscribeCode: 'CorporateEarning',
    AlertName: 'Kết quả kinh doanh',
    En_AlertName: 'Corporate Earning',
    AlertType: 'Event',
    AlertGroup: 'Notification.Event',
    Status: '1',
    Vi_NotificationTemplate: 'Báo cáo tài chính hợp nhất năm {0}',
    En_NotificationTemplate: '{0} consolidated financial statements',
    SortOrder: '128',
  },
  CorporateEarningUnConsolidatedQ: {
    AlertId: '90',
    AlertCode: 'CorporateEarningUnConsolidatedQ',
    SubscribeCode: 'CorporateEarning',
    AlertName: 'Kết quả kinh doanh',
    En_AlertName: 'Corporate Earning',
    AlertType: 'Event',
    AlertGroup: 'Notification.Event',
    Status: '1',
    Vi_NotificationTemplate: 'Báo cáo tài chính công ty mẹ Q{1}-{0}',
    En_NotificationTemplate: 'Q{1}-{0} financial statements (Holding company)',
    SortOrder: '128',
  },
  CorporateEarningUnConsolidatedY: {
    AlertId: '91',
    AlertCode: 'CorporateEarningUnConsolidatedY',
    SubscribeCode: 'CorporateEarning',
    AlertName: 'Kết quả kinh doanh',
    En_AlertName: 'Corporate Earning',
    AlertType: 'Event',
    AlertGroup: 'Notification.Event',
    Status: '1',
    Vi_NotificationTemplate: 'Báo cáo tài chính công ty mẹ năm {0}',
    En_NotificationTemplate: '{0} financial statements (Holding company)',
    SortOrder: '128',
  },
  WatchoutYear: {
    AlertId: '99',
    AlertCode: 'WatchoutYear',
    SubscribeCode: 'WatchoutYear',
    AlertName:
      'Doanh nghiệp có tình hình tài chính cần chú  (Đánh giá theo quý)',
    En_AlertName: 'Watch-out Year',
    AlertType: 'Fundamental',
    AlertGroup: 'Notification.Fundamental',
    Status: '1',
    Vi_NotificationTemplate:
      'Chỉ tiêu {0} bị đánh giá Nguy hiểm trong kì đánh giá Năm {2}',
    En_NotificationTemplate:
      'Indicator {0} is rated Watch-Out in Year {2} of the Review Period',
    SortOrder: '9',
  },
};

export const getAlertTitle = (item, locale) => {
  try {
    const isEn = locale.toLowerCase() === listLanguage.en.toLowerCase();
    const titleKey = isEn ? 'En_AlertName' : 'AlertName';

    return alertDefinitionByCode[item.alertCode][titleKey];
  } catch (e) {}
};

const isFunction = text => {
  const regex = /\w+?\(.+?\)/;
  return regex.test(text);
};

export const getAlertMessage = (item, locale) => {
  try {
    const params = JSON.parse(item.message);
    const isEn = locale.toLowerCase() === listLanguage.en.toLowerCase();
    const textKey = isEn
      ? 'En_NotificationTemplate'
      : 'Vi_NotificationTemplate';
    let text = alertDefinitionByCode[item.alertCode][textKey];

    const formatDate = param => {
      const date = moment(param);
      const format = isEn ? 'DD-MM-YYYY' : 'MM-DD-YYYY';

      return date.format(format);
    };

    const getOrganName = organCode => {
      const organizationByOrganCode = store.getState()[COMMON_REDUCER]
        .listOrganizationByOrganCode;
      return organizationByOrganCode[organCode].organShortName;
    };

    const getIcbName = icbCode => {
      const icbByOrganCode = store.getState()[COMMON_REDUCER]
        .listIndustryByIcbCode;

      return icbByOrganCode[icbCode].icbName;
    };

    const getMessage = (viMessage, enMessage) => {
      return isEn ? enMessage : viMessage;
    };

    params.forEach((value, index) => {
      text = text.replace(
        `{${index}}`,
        isFunction(value) ? eval(value) : value,
      );
    });

    return text;
  } catch (e) {
    return '';
  }
};
